import React, { useContext, useEffect, useReducer, useState } from 'react'
import { Context } from '../../Context/Context'
import { isUserVerifiedApi } from '../../Constants';
import ProfileDetailsView from './ProfileDetailsView';
import ProfessionalAccountUpdatesModal from 'Modals/ProfessionalAccountUpdatesModal';
import ProfessionalAccountUpdates from './ProfessionalAccountUpdates';
import SeeUpdatesMadeOnAccount from './SeeUpdatesMadeOnAccount';
import EmailNotification from './EmailNotification';
import { Link, useNavigate } from 'react-router-dom';
import EmailNotificationSettingAssistant from './EmailNotificationSettingAssistant';
import useIsMobile from 'Hooks/useIsMobile';

function ProfessionalDetails({setShowEdit, setActivePanel}) {
  const [showUpdateDetails, setShowUpdateDetails] = useState(false);
  const [reRenderData, setReRenderData] = useState(false);
 const {makeApiCallFunc} = useContext(Context);
 const isMobile = useIsMobile();
 const {userDetails} = useContext(Context);
 const navigate = useNavigate();
 const {profilePic} = userDetails;
 const attorneyProfilePic = userDetails?.attorney?.profilePic;
 const [isUserVerified, setIsUserVerified] = useState();
 const [isUserEditing, setIsUserEditing] = useState();
 const [responseReceived, setResponseReceived] = useState(false);
  const [updatesSent, setUpdatesSent] = useState(null);

    useEffect(() => {
        if(!userDetails.isUserAssistant)
          {
            makeApiCallFunc(
              isUserVerifiedApi,
              {verified: userDetails?.verified},
              ({data}) => {
                console.log(data);
                console.log("userDetails in professional details", userDetails);
                
                setResponseReceived(true);
                setIsUserVerified(data.verified);
                setUpdatesSent(data?.approvalList);
              },
              (data) => {
                setResponseReceived(true);
                console.log(data)
              }
            )
          }
        
      },[reRenderData])
    

      
    const data = {
        "Name" : userDetails?.firstName+" "+userDetails?.lastName,
        "Email address"  : userDetails?.email,
        "Company" : userDetails?.company? userDetails?.company : "--",
        "Phone Number" : userDetails?.phoneNumber? userDetails?.phoneNumber : "--",
        "Experience" : userDetails?.experience ? userDetails.experience :  "--",
        "Designation" : userDetails?.legalType ? userDetails.legalType :  "--",
        "Law Firm URL" : userDetails?.lawFirmLink ? userDetails.lawFirmLink :  "--",
        "LinkedIn URL" : userDetails?.linkedin ? userDetails.linkedin :  "--",
       
    }
    const prefData = {
      "Preferred case type" : userDetails?.casePref ? userDetails.casePref :  "--" ,
      "Preferred state" : userDetails?.statePref ? userDetails.statePref :  "--",
    }
     const getButtonName = () => {
     switch(isUserVerified)
     {
      case 0:
        return "Complete Profile";
      case 1:
      case 2:
      case 3:
        return "Edit Profile";
      case 4:
      case 5:
        return "Resubmit Profile";
      default:
        return "Edit Profile";
     } 
    }
    const attorneyData = {
        "Name" : userDetails?.attorney?.firstName+" "+userDetails?.attorney?.lastName,
        "Email Id"  : userDetails?.attorney?.email,
        "Law Firm URL" : userDetails?.attorney?.lawFirmLink ? userDetails.attorney?.lawFirmLink :  "--",
        "LinkedIn URL" : userDetails?.attorney?.linkedin ? userDetails.attorney?.linkedin :  "--",
    }
    const showEditOrPopup = () => {
      if(isUserVerified === 2 || isUserVerified === 3)
      {
          setIsUserEditing(true);
      }
      else
      {
        setShowEdit(true);
      }
    }
     const inReview = (isUserVerified !== 0 && isUserVerified !== 1) && updatesSent;
     return (
      <>
      {
        isUserEditing &&
        <ProfessionalAccountUpdatesModal
        uploadNew = {isUserEditing}
        onClose = {() => setIsUserEditing(false)}
        onSubmit = {() => {setShowEdit(true)}}
        />
      }
      <ProfileDetailsView
        title={userDetails?.firstName+" "+userDetails?.lastName}
        showAvatar
        avatar={profilePic}
        verified={!!userDetails?.verified}
        isUserVerified={isUserVerified}
        updatesSent={updatesSent}
        buttonName={responseReceived || userDetails?.isUserAssistant ? getButtonName() : null}
        onEdit={showEditOrPopup}
        updates={inReview &&
          <SeeUpdatesMadeOnAccount
          labels = {{
                  "Profile picture" : "profilePic",
                  "First name" : "firstName",
                  "Last name" : "lastName",
                  "Email" : "email",
                  "Company" : "company",
                  "Designation" : "legalType",
                  "Law Firm Link" : "lawFirmLink",
                  "LinkedIn URL" : "linkedin",
                  "Phone number" : "phoneNumber",
                  "Experience" : "experience",
                  "Case Preference" : "casePref",
                  "State Preference" : "statePref"
                 }}
          updatesSent={updatesSent}
          setReRenderData={setReRenderData}
          isDenied={(isUserVerified === 4 || isUserVerified === 5) ? true : false}
          showEditOrPopup={showEditOrPopup}
          variant="cards"
          />}
        sections={[
          { title: (isUserVerified !== 0 && isUserVerified !== 1) ? "Account details" : "Profile details", note: (isUserVerified !== 0 && isUserVerified !== 1) ? "Not affected by the review above." : null, data },
          !userDetails.isUserAssistant && { title: "Case preferences", data: prefData },
        ]}
      />
    </>
  )
}

export default ProfessionalDetails